// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3Q1Tf","fileBtn":"File_fileBtn__2XJqq","closeBtn":"File_closeBtn__2RtFW","fileSelected":"File_fileSelected__TaaH_","disabled":"File_disabled__1RsVz"};